import { useEffect } from 'react';
import { ReactSession } from "react-client-session";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Principal from "./component/Principal";
import { Toaster } from 'react-hot-toast'
import EncuestaRespond from "./component/Formularios/EncuestaRespond";
import ProtocoloDirectoInicio from "./component/Protocolos/ProtocoloDirectoInicio";
import ReclutamientoPersonal from "./component/Reclutaminetos/ReclutamientoPersonal";
import PrincipalTarjetaMiguel from "./component/PrincipalTarjetaMiguel";
import AutorizarEncuestaGeneral from "./component/Formularios/AutorizarEncuestaGeneral";
import Revista from "./component/PaginaRevista/Revista";
import Capacitaciones from './component/PaginaCapacitaciones/Capacitaciones';
import ValoresCorporativosEjemplares from './component/PaginaValoresCorporativosEjemplares/ValoresCorporativosEjemplares';
import FexcoInauguracion from './component/PaginaFexcoInauguracion/FexcoInauguracion';
import PosesionCbba from './component/PaginaPosesionCbba/PaginaPosesionCbba';
import PosesionSC from './component/PaginaPosesionSC/PosesionSC';
import CampeonatoSC from './component/PaginaCampeonatoSC/campeonatoSC';
import msg from './component/Tools/MsgUtils';
import EventosCbba from './component/PaginaEventosCbba/eventosCbba';
import EventosSC from './component/PaginaEventosSC/eventosSC';
import { enviarErroresPendientes } from "./component/Utils/diagnosticoAsistencia";

const server = process.env.REACT_APP_SERVER;

function App() {
  ReactSession.setStoreType("localStorage");
  window.addEventListener("error", (event) => {
    var info = window.location.origin + ` RRHH ${event.type}: ${event.message}:${event.lineno}:${event.colno}:${event.error}\n`;
    fetch(`${server}/sqlComun/sendMesajeError`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ 'mensaje': JSON.stringify(info) })
    })
      .then(res => res.json())
      .then(data => {
        //console.log(data);
      })
      .catch(err => {
        //console.log(err);
      });
  });

  useEffect(() => {
      const server = process.env.REACT_APP_SERVER;

      enviarErroresPendientes(server);
  }, []);

  useEffect(() => {

    if (localStorage.getItem("info")) {
      let informacion_empleado = JSON.parse(localStorage.getItem("info"));
      if (informacion_empleado.ID_EMPLEADO && informacion_empleado.ID_REGIONAL_ACTUAL) {
        let id_empleado = informacion_empleado.ID_EMPLEADO;
        let regional = informacion_empleado.ID_REGIONAL_ACTUAL;
        getPermisos(id_empleado, regional);
      }
    }
  }, []);

  async function getPermisos(id_empleado, regional) {

    try {
      let respuesta = await fetch(`${server}/sqlComun/empleados/getPermisosEmpleadoDadoID`, {
        method: "POST",
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id_empleado: id_empleado,
          regional: regional
        })
      });

      if (respuesta.ok) {
        let data = await respuesta.json()
        let nuevaInfo = JSON.parse(localStorage.getItem("info"));
        nuevaInfo.PERMISO = data.ok[0]["LISTAGG(R.ID_PERMISO,':')WITHINGROUP(ORDERBYR.ID_PERMISO)"]
        localStorage.setItem("info", JSON.stringify(nuevaInfo));
      } else {
        msg.msgError(respuesta.error)
      }
    } catch (error) {
      msg.msgError(error);
    }
  }

  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<Principal />} />
          <Route path='/Encuesta/*' element={<EncuestaRespond />} />
          <Route path='/EncuestaGeneral/*' element={<AutorizarEncuestaGeneral />} />
          <Route path='/VerProtocolos/*' element={<ProtocoloDirectoInicio />} />
          <Route path='/Reclutamiento/*' element={<ReclutamientoPersonal />} />
          <Route path='/TarjetaMiguel' element={<PrincipalTarjetaMiguel />} />
          <Route path='/revista' element={<Revista />} />
          <Route path='/capacitaciones' element={<Capacitaciones />} />
          <Route path='/valoresCorporativosEjemplares' element={<ValoresCorporativosEjemplares />} /> 
          <Route path='/fexcoInauguracion' element={<FexcoInauguracion/>}/>
          <Route path='/posesionCbba' element={<PosesionCbba/>}/>
          <Route path='/posesionSC' element={<PosesionSC/>}/>
          <Route path='/campeonatoSC' element={<CampeonatoSC/>}/>
          <Route path='/eventosCbba' element={<EventosCbba/>}/>
          <Route path='/eventosSC' element={<EventosSC/>}/>
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-left"
        reverseOrder={false}
      />
    </div>
  );
}

export default App;
